import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';

export class BuyFeatureButtonHideUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.emit('Game.command.buyFeature.hide');
        this.onExecuted?.();
    }

    getName(): string {
        return 'BuyFeatureButtonDisableUIAct';
    }
}